// test2762
(2762 && 0);
